import {
  takeEvery, call, put, fork
} from 'redux-saga/effects';
import { loadHistory, saveHistory } from 'src/utils/storage/taskHistory';
import * as actions from '../actions/taskHistoryActions';
import * as api from '../api/taskHistory';

function* getArtemisTaskHistory(FisNo) {
  try {
    let data = loadHistory(FisNo.FisNo);
    // if (data.length === 0 && window.navigator.onLine) { // localde yok
      const result = yield call(api.getArtemisTaskHistory, FisNo);
      data = result.data === '' ? [] : result.data;
      saveHistory(FisNo.FisNo, data);
    // }
    yield put(actions.taskHistorySuccess(data));
  } catch (error) {
    yield put(actions.setError(error));
    console.error(error);
  }
}

function* watchGetTaskHistoryRequest() {
  yield takeEvery(actions.Types.GET_TASK_HISTORY_REQUEST, getArtemisTaskHistory);
}

const taskHistorySagas = [fork(watchGetTaskHistoryRequest)];

export default taskHistorySagas;
